import { MediaElement } from 'editor/src/store/design/types';
import isStaticFlagChangeAllowed from 'editor/src/store/editor/selector/isStaticFlagChangeAllowed';
import { useSelector } from 'editor/src/store/hooks';

function useIsInteractable(elementData: MediaElement, ignorePersonalizationLock: boolean) {
  // A host that lets the user toggle Static is the template author's: they must be able to pick a
  // static element back up. Everyone else gets it as fixed background that clicks pass through.
  const staticFlagChangeAllowed = useSelector(isStaticFlagChangeAllowed);
  const isInteractable = !elementData.hidden && (!elementData.personalizationLocked || ignorePersonalizationLock);

  return isInteractable && (!elementData.static || staticFlagChangeAllowed);
}

export default useIsInteractable;
